import classNames from 'classnames';
import React, { ChangeEvent, FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AUTH_KEYS, NS } from '../../../i18n/constants/keys';
import { Button } from '../../../ui';
import { TextInput } from '../../../ui/input/text_input/text_input';
import styles from '../login_register.module.css';

type ResetPasswordProps = {
  handleSubmit: (event: FormEvent<HTMLFormElement>, email: string) => void;
  onClose: () => void;
  open: boolean;
};

export const ResetPassword = ({
  handleSubmit,
  onClose,
  open,
}: ResetPasswordProps) => {
  const { t } = useTranslation(NS.auth);
  const [email, setEmail] = useState<string>('');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  return (
    <>
      { open && (
        <div
            className={classNames(
              'fixed z-[60] inset-0 backdrop-blur-md bg-slate-900/40 flex justify-center items-center p-4 transition-all duration-500',
              styles.modalFadeIn,
            )}
        >
          <div
              className={classNames(
                'bg-white/90 backdrop-blur-3xl px-8 py-10 rounded-[2.5rem] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.1)] w-full max-w-xl border border-white/50 relative overflow-hidden',
                styles.modalZoomIn,
              )}
          >
            { /* Decorative background element */ }
            <div className='absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-40 h-40 bg-emerald-100/50 rounded-full blur-3xl pointer-events-none' />

            <div className='flex flex-col items-center mb-8'>
              <div className='w-16 h-16 rounded-2xl bg-emerald-50 flex items-center justify-center mb-6 shadow-sm border border-emerald-100'>
                <svg
                    className='w-8 h-8 text-emerald-600'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                >
                  <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z'
                  />
                </svg>
              </div>
              <h2 className='text-3xl font-bold text-slate-900 text-center tracking-tight'>
                { t(AUTH_KEYS.resetPassword.title) }
              </h2>
              <p className='text-slate-500 text-center mt-2 max-w-sm'>
                { t(AUTH_KEYS.resetPassword.subtitle) }
              </p>
            </div>

            <form
                className={classNames(styles.form)}
                onSubmit={(event: FormEvent<HTMLFormElement>) =>
                  handleSubmit(event, email)
                }
                data-testid='login-form'
            >
              <div className='space-y-6'>
                <TextInput
                    type='email'
                    label={t(AUTH_KEYS.resetPassword.emailAddress)}
                    name='email'
                    data-testid='email'
                    value={email}
                    onChange={handleChange}
                    required={true}
                />

                <div className='flex flex-col sm:flex-row justify-center gap-4 w-full pt-4'>
                  <Button
                      label={t(AUTH_KEYS.resetPassword.cancel)}
                      onClick={onClose}
                      variant='secondary'
                  />
                  <Button
                      onClick={() => {}}
                      label={t(AUTH_KEYS.resetPassword.sendResetMail)}
                      variant='primary'
                      type='submit'
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      ) }
    </>
  );
};
